import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { AlertCircle } from 'lucide-react';

interface OutstandingIssuesModalProps {
  isOpen: boolean;
  onClose: () => void;
  issueCount: number;
}

export function OutstandingIssuesModal({
  isOpen,
  onClose,
  issueCount,
}: OutstandingIssuesModalProps) {
  const bgColor = useColorModeValue('amber.100', 'amber.900');
  const iconColor = useColorModeValue('amber.600', 'amber.300');

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody py={6}>
          <VStack spacing={6} align="center">
            <Icon
              as={AlertCircle}
              w={16}
              h={16}
              color={iconColor}
              bg={bgColor}
              borderRadius="full"
              p={4}
            />
            <Text fontSize="2xl" fontWeight="bold" textAlign="center">
              Cannot Mark as "On Track"
            </Text>
            <Text color="gray.600" textAlign="center" maxW="md">
              This rock has <Text as="span" fontWeight="semibold" color="gray.900">
                {issueCount}
              </Text>{' '}
              outstanding {issueCount === 1 ? 'issue' : 'issues'}.
            </Text>
            <Text color="gray.600" textAlign="center" maxW="md">
              Please resolve all issues before marking this rock as on track.
            </Text>
            <Button onClick={onClose} colorScheme="blue" w="full" maxW="xs">
              OK
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

